<template>
  <div class="subject-box">
    <div class="subject-top">
      <div class="subject-top_l">{{ subject.Title }}</div>
      <div class="subject-top_r"  @click="goSubject">
        更多 >
      </div>
    </div>
    <div class="subject-pic" v-if="subject.PictureUrl">
        <img :src="subject.PictureUrl" alt v-lazy="subject.PictureUrl"  @click="goSubject"/>
    </div>
    <div class="subject-list">
      <van-row gutter="35">
        <van-col span="8" v-for="p in subject.Products" :key="p.ProId">
          <SubjectItemProduct :product="p" ></SubjectItemProduct>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import SubjectItemProduct from "./SubjectItemProduct.vue";

export default {
  name: "SubjectItem",
  components: { SubjectItemProduct },
  props: {
    subject: {},
  },
  data() {
    return {
      imgs: "",
    };
  },
  methods: {
    goSubject() {
      // this.$router.push({
      //   path: "/subject",
      //   query: { id: this.subject.Id, title: this.subject.Title },
      // });
       this.$router.push({
        path: `/subject/${this.subject.Id}`
      });
    },
  },
};
</script>

<style lang="less" scoped>
.subject-box {
  background-color: #fff;
  .subject-top {
    height: 45px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    &_l {
      font-size: 16px;
      flex: 1;
      font-weight: 600;
    }
    &_r {
      font-size: 14px;
      width: 80px;
        color: #969799;
      text-align: right;
      a {
        color: #969799;
      }
    }
  }
  .subject-pic {
    margin: 0 15px;
    img {
      border-radius: 8px;
    }
  }
  .subject-list {
    box-sizing: border-box;
    padding: 10px 15px;
  }
}
</style>
